let locales = {
    permissionEdit_title: 'Create Permission',
    permissionEdit_titleEdit: 'Edit Permission',
    permissionEdit_warningTitle: 'Attenzione: le autorizzazioni create devono essere adattate al codice sorgente per funzionare correttamente.',
};

export default locales;